// Global reference for Artesian token error modal trigger
export const artesianTokenErrorModalRef = { show: null as (() => void) | null };

// Make it available on window object for console testing (development only)
declare global {
  interface Window {
    artesianTokenErrorModalRef?: typeof artesianTokenErrorModalRef;
  }
}

if (typeof window !== 'undefined' && import.meta.env.DEV) {
  window.artesianTokenErrorModalRef = artesianTokenErrorModalRef;
}
